import classNames from "classnames";
import { noop } from "lodash";
import { Icon } from "@circle-react-shared/Icon";

interface LeftNavigationButtonProps {
  isDisabled?: boolean;
  isLoading?: boolean;
  onClick: () => void;
}

export const LeftNavigationButton = ({
  onClick = noop,
  isDisabled = false,
  isLoading = false,
}: LeftNavigationButtonProps) => {
  const iconType = isLoading ? "loader" : "20-chevron-left";

  return (
    <button
      type="button"
      className={classNames(
        "fixed top-1/2 -translate-y-1/2",
        "hidden",
        "size-24",
        "isolate z-10 items-center justify-center",
        "transition-all duration-300 ease-in-out",
        "md:flex",
        "md:left-[calc(50%-400px-96px)]",
        "lg:left-[calc(50%-400px-128px)]",
      )}
      onClick={isDisabled ? undefined : onClick}
      disabled={isDisabled}
    >
      <div
        className={classNames(
          "bg-primary hover:bg-tertiary text-default hover:text-dark",
          "relative size-10",
          "flex items-center justify-center rounded-full",
          { "cursor-not-allowed opacity-50": isDisabled },
        )}
      >
        <Icon size={20} type={iconType} />
      </div>
    </button>
  );
};
